import React, { PropsWithChildren } from 'react';
import ivclass from '@invideoio/web-shared/Modules/IVClass';
import { CSSProperties } from 'react';
import AssetIcon from '@components/asset-icon/AssetIcon';
import { AssetsAppName, getWebAssetsUrl } from '@utils/web-assets';

interface SlideDrawerProps {
  isOpen: boolean;
  onClose: () => void;
  drawerHead?: () => JSX.Element;
  drawerStyles?: CSSProperties;
}

function SlideDrawer(props: PropsWithChildren<SlideDrawerProps>) {
  const { isOpen, onClose, drawerHead, drawerStyles = {}, children } = props;
  return (
    <div
      className={ivclass(
        'slide-drawer',
        'iv-h-full iv-absolute iv-top-0 iv-right-0  iv-z-50',
        'iv-bg-grey-0',
        'iv-translate-x-full',
        'iv-transition-transform iv-duration-150',
        'iv-border-l iv-border-grey-7',
        isOpen && 'iv-translate-x-0',
      )}
      style={{
        ...drawerStyles,
      }}
    >
      <div
        className={ivclass(
          'iv-flex iv-justify-between iv-items-center',
          'iv-px-20 iv-py-15 iv-mb-10 iv-border-b iv-border-grey-7',
        )}
      >
        {drawerHead && drawerHead()}
        <button className={ivclass()} type="button" onClick={onClose}>
          <AssetIcon
            appName={AssetsAppName.COMMON}
            path={`/header-icons/cross.svg`}
            width={12}
            height={12}
          />
        </button>
      </div>
      {children}
    </div>
  );
}

export default SlideDrawer;
